import React from 'react';
import PropTypes from 'prop-types';
import { Send } from '@mui/icons-material';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import { Button, Checkbox, Input, Modal, Textarea } from 'components/ui';

import * as Styled from './SendDocumentsModal.styles';

const schema = Yup.object({
  title: Yup.string().trim().required('Pole wymagane'),
  message: Yup.string().trim().required('Pole wymagane'),
  sendCopyToMe: Yup.bool(),
});

export const SendDocumentsModal = ({ onClose, documentsCount, onConfirm, isSending }) => {
  const { values, errors, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      title: '',
      message: '',
      sendCopyToMe: false,
    },
    validationSchema: schema,
    validateOnChange: false,
    onSubmit: (values) => {
      onConfirm(schema.cast(values));
    },
  });

  return (
    <Modal title="Nowa wiadomość e-mail" onClose={onClose}>
      <Styled.Form>
        <Styled.Message>Wpisz treść wiadomości dla księgowego i wyślij Dokumenty kosztowe emailem. </Styled.Message>
        <Styled.DocumentsInfo>Dokumenty kosztowe do wysłania: {documentsCount}</Styled.DocumentsInfo>
        <Input
          label="Temat*"
          value={values.title}
          onChange={(value) => setFieldValue('title', value)}
          error={errors.title}
        />
        <Textarea
          label="Wiadomość*"
          value={values.message}
          onChange={(value) => setFieldValue('message', value)}
          error={errors.message}
        />
        <Checkbox
          label="Wyślij kopię na mój adres e-mail"
          onChange={(value) => setFieldValue('sendCopyToMe', value)}
          checked={values.sendCopyToMe}
        />
        <Styled.Actions>
          <Button onClick={onClose} variant="outlined">
            Anuluj
          </Button>
          <Button onClick={handleSubmit} className="sendButton" loading={isSending}>
            Wyślij <Send />
          </Button>
        </Styled.Actions>
      </Styled.Form>
    </Modal>
  );
};

SendDocumentsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  documentsCount: PropTypes.number.isRequired,
  isSending: PropTypes.bool,
};
